import { render, staticRenderFns } from "./hazardFacility.vue?vue&type=template&id=b3750a02"
import script from "./hazardFacility.vue?vue&type=script&lang=js"
export * from "./hazardFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3750a02')) {
      api.createRecord('b3750a02', component.options)
    } else {
      api.reload('b3750a02', component.options)
    }
    module.hot.accept("./hazardFacility.vue?vue&type=template&id=b3750a02", function () {
      api.rerender('b3750a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/hcf/hazardFacility.vue"
export default component.exports